// 手机号/邮箱验证码登录错误信息
export const codeLoginError = {
  C10013: "用户未注册",
  C100131: "用户不存在",
  C100134: "手机号未激活",
  C100135: "手机号不存在",
  C10007: "手机验证码登录失败",
  C10142: "邮箱未激活",
  C10143: "邮件地址不存在",
  C10144: "邮箱验证码登录失败",
  C10145: "手机号和邮箱不能为空",
  C10059: "获取验证码失败，程序错误",
  C10060: "手机号输入为空",
  C10068: "验证码已经被使用过或者错误的验证码",
};

// 密码登录错误码
export const passwordLoginError = {
  C100134: "手机号未认证",
  C100131: "手机号未注册",
  C100135: "手机号未注册",
  C10124: "密码已过期，请修改密码",
  C10011: "登录账号或手机号不存在",
  C10012: "密码错误",
  C10013: "账号未注册",
  C10142: "邮箱未认证",
  C10143: "邮箱未注册",
};
